import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import TuneIcon from '@mui/icons-material/Tune';
import { Box, Button } from '@mui/material';

const FilterButtons = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        mt: 4,
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          bgcolor: 'rgba(20, 24, 28, 0.95)',
          p: 2,
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        <Button
          startIcon={<TuneIcon />}
          sx={{
            color: '#fff',
            bgcolor: 'rgba(36,41,46,0.9)',
            borderRadius: 2,
            px: 3,
            fontWeight: 600,
            fontSize: 16,
            textTransform: 'none',
            '&:hover': { bgcolor: 'rgba(36,41,46,1)' },
          }}
        >
          Filter By
        </Button>
        <Button
          startIcon={<AttachMoneyIcon />}
          sx={{
            color: '#fff',
            bgcolor: 'rgba(36,41,46,0.9)',
            borderRadius: 2,
            px: 3,
            fontWeight: 600,
            fontSize: 16,
            textTransform: 'none',
            '&:hover': { bgcolor: 'rgba(36,41,46,1)' },
          }}
        >
          Price
        </Button>
        <Button
          startIcon={<LocationOnIcon />}
          sx={{
            color: '#fff',
            bgcolor: 'rgba(36,41,46,0.9)',
            borderRadius: 2,
            px: 3,
            fontWeight: 600,
            fontSize: 16,
            textTransform: 'none',
            '&:hover': { bgcolor: 'rgba(36,41,46,1)' },
          }}
        >
          Location
        </Button>
        <Button
          startIcon={<EventAvailableIcon />}
          sx={{
            color: '#fff',
            bgcolor: 'rgba(36,41,46,0.9)',
            borderRadius: 2,
            px: 3,
            fontWeight: 600,
            fontSize: 16,
            textTransform: 'none',
            '&:hover': { bgcolor: 'rgba(36,41,46,1)' },
          }}
        >
          Availability
        </Button>
      </Box>
    </Box>
  );
};

export default FilterButtons; 